function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  fill: "white",
  stroke: "#1C3BA4"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.293 7.293L10 13.586L7.70704 11.293C7.51844 11.1108 7.26584 11.01 7.00364 11.0123C6.74144 11.0146 6.49063 11.1198 6.30522 11.3052C6.11981 11.4906 6.01465 11.7414 6.01237 12.0036C6.01009 12.2658 6.11088 12.5184 6.29304 12.707L9.29304 15.707C9.48057 15.8945 9.73488 15.9998 10 15.9998C10.2652 15.9998 10.5195 15.8945 10.707 15.707L17.707 8.707C17.8892 8.5184 17.99 8.26579 17.9877 8.0036C17.9854 7.7414 17.8803 7.49059 17.6949 7.30518C17.5095 7.11977 17.2586 7.0146 16.9964 7.01232C16.7342 7.01005 16.4816 7.11084 16.293 7.293Z",
  fill: "#1C3BA4"
}));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.f6ff9114.svg";
export { ForwardRef as ReactComponent };